import React from "react";

const sk = "animate-pulse bg-gray-400 dark:bg-gray-700 rounded";

// ✅ Card Skeleton (for expense cards)
export const CardSkeleton: React.FC = () => (
  <div className="grid grid-cols-[auto_1fr_auto_auto_auto_auto] max-md:grid-cols-[auto_1fr_auto] gap-4 items-center p-4 bg-[var(--card-bg)] rounded-xl mb-3 border border-[var(--border-color)]">
    <div className={`${sk} w-5 h-5`} />
    <div className={`${sk} h-4 w-[150px]`} />
    <div className={`${sk} h-4 w-20`} />
    <div className={`${sk} h-4 w-10 max-md:hidden`} />
    <div className={`${sk} w-[70px] h-6 rounded-full max-md:hidden`} />
    <div className={`${sk} w-6 h-6 rounded-full`} />
  </div>
);

// ✅ Table Row Skeleton (for expense table)
export const TableRowSkeleton: React.FC = () => (
  <tr>
    <td className="p-4">
      <div className={`${sk} h-4`} />
    </td>
    <td className="p-4">
      <div className={`${sk} h-4 w-[60px]`} />
    </td>
    <td className="p-4">
      <div className={`${sk} h-4 w-[60px]`} />
    </td>
    <td className="p-4">
      <div className={`${sk} w-[70px] h-6 rounded-full`} />
    </td>
    <td className="p-4">
      <div className={`${sk} h-4 w-[60px]`} />
    </td>
    <td className="p-4">
      <div className={`${sk} w-9 h-9 rounded-full`} />
    </td>
    <td className="p-4">
      <div className="flex gap-2 justify-center">
        <div className={`${sk} w-9 h-9 rounded-full`} />
        <div className={`${sk} w-9 h-9 rounded-full`} />
      </div>
    </td>
  </tr>
);

// ✅ Stat Card Skeleton (for dashboard stat cards)
export const StatCardSkeleton: React.FC = () => (
  <div className="bg-card-light dark:bg-card border border-card-border-light dark:border-card-border rounded-card p-4 md:p-6 shadow-glass-light dark:shadow-glass backdrop-blur-glass">
    <div className="flex justify-between items-start mb-4">
      <div>
        <div className={`${sk} h-4 w-[100px] mb-2`} />
        <div className={`${sk} h-8 w-[120px]`} />
      </div>
      <div className={`${sk} w-6 h-6 rounded-full`} />
    </div>
    <div className={`${sk} h-3 w-[150px] mt-3`} />
  </div>
);

// ✅ Income Card Skeleton
export const IncomeCardSkeleton: React.FC = () => (
  <div className="flex justify-between items-center p-4 bg-[var(--input-bg)] rounded-lg mb-2 border border-[var(--border-color)]">
    <div className="flex-1">
      <div className={`${sk} h-4 w-[150px]`} />
      <div className={`${sk} h-[14px] w-[180px] mt-1`} />
    </div>
    <div className="flex gap-2">
      <div className={`${sk} w-9 h-9 rounded-full`} />
      <div className={`${sk} w-9 h-9 rounded-full`} />
    </div>
  </div>
);

// ✅ Chart Skeleton
export const ChartSkeleton: React.FC = () => (
  <div className="bg-[var(--card-bg)] p-6 rounded-xl border border-[var(--border-color)]">
    <div className="flex justify-between items-center mb-6">
      <div className={`${sk} w-[150px] h-5`} />
      <div className={`${sk} w-[70px] h-6 rounded-full`} />
    </div>
    <div className="h-[250px] flex items-end justify-center">
      <div className="flex gap-8 items-end w-full h-full px-8">
        {([60, 80, 40, 70] as const).map((h, i) => (
          <div
            key={i}
            className={`${sk} flex-1 rounded-t-lg min-h-[40px]`}
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
    </div>
  </div>
);
